import { CAMPAIGN_VARIABLE_LABELS } from "@signalist/shared-types";

/**
 * The builder's variable labels. The map lives in `@signalist/shared-types` (PREC-4370), so the
 * API's `list_campaign_variables` names variables exactly as the builder's picker does.
 */
export default {
	suggestions: CAMPAIGN_VARIABLE_LABELS,
};
